import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';



function CriarADM() {
  const navigate = useNavigate();

  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/adm')

  const [formValue, setFormValue] = useState({
    nomeAdministrador: '',
    tipouser: '5',
    login: '',
    senha: ''
  });

  const handleSubmit = async (values) => {
    console.log(formValue);
    values.preventDefault();
    util.isSubmitting()
    const result = await api.registrarADMApi(formValue);
    result ? toast.success("Criado com sucesso!") && navigate("/area-adm") : null;
    util.isSubmitting()
    
  }

  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
      height:"100vh", minHeight:'500px',display:"flex", justifyContent:"center", alignContent:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column align-items-center'>

          <MDBCard className='bg-dark text-white h-75 w-50' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-4'>Bem vindo, {userLogin.nomeusuario}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={handleSubmit}>
                    <MDBValidationItem feedback='Por favor digite seu nome!' invalid>
                      <MDBInput 
                        wrapperClass='mb-5 w-100' 
                        labelClass='text-white' 
                        label='Nome' 
                        name='nomeAdministrador'
                        id='formContronomeAdministrador' 
                        type='text' 
                        size="lg"
                        value={formValue.nomeAdministrador}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite uma senha válida!' invalid>
                      <MDBInput 
                        wrapperClass='mb-5 w-100' 
                        labelClass='text-white' 
                        label='Login' id='formControLogin' 
                        type='text' 
                        size="lg" 
                        style={{color:"white"}}
                        name='login'
                        value={formValue.login}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        minLength={3}
                        
                        />
                    </MDBValidationItem>
                    <MDBValidationItem feedback='Por favor digite uma senha válida!' invalid>
                      <MDBInput 
                        wrapperClass='mb-5 w-100' 
                        labelClass='text-white' 
                        label='Senha' id='formControPassword' 
                        type='password' 
                        size="lg" 
                        style={{color:"white"}}
                        name='senha'
                        value={formValue.senha}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        minLength={3}
                        
                        />
                    </MDBValidationItem>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 btn-home' 
                        color='white' 
                        size='lg'
                        type='submit'   
                        id='submitForm'  
                        disabled={formValue.senha.length < 3 || formValue.nomeAdministrador.length < 1 || formValue.login.length < 1}                 
                        >
                        
                        Registrar
                      </MDBBtn>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/area-adm")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default CriarADM;